/**
 * @file 重導向頁面
 * @description 根據使用者登入狀態與權限導向對應頁面
 */
import { useEffect, ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import localStorageUtil from 'utils/localStorageUtil';
import LocalStorageKeys from 'constants/localStorageKeys';
import { CHECK_LOGIN } from 'config/config';
import homePageType, { HomePageTypeKey } from 'constants/homePageType';

/** 使用者資訊介面 */
interface UserInfo {
  homePage?: HomePageTypeKey;
  [key: string]: unknown;
}

/**
 * 重導向元件
 */
function RedirectUrl(): ReactNode {
  const location = useLocation();
  const navigate = useNavigate();
  const checkLogin = CHECK_LOGIN;
  // 檢查使用者登入狀態，未登入則導向login
  useEffect(() => {
    const userInfo = localStorageUtil.getItem<UserInfo>(LocalStorageKeys.UserInfo);
    if (checkLogin) {
      if (!userInfo && location.pathname !== '/login') {
        navigate('/');
      } else if (userInfo) {
        // 根據使用者權限 跳轉頁面
        if (userInfo.homePage) {
          navigate(homePageType[userInfo.homePage]);
        } else {
          navigate('/');
        }
      }
    }
  }, [checkLogin, location, navigate]);

  return <div></div>;
}

export default RedirectUrl;
